/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `APPLIED` - Applied
 * * `SHIFT_OFFERED` - Shift Offered
 * * `SHIFT_SCHEDULED` - Shift Scheduled
 * * `JOB_OFFERED` - Job Offered
 * * `ACCEPTED` - Accepted
 * * `REJECTED` - Rejected
 * * `SHIFT_DECLINED` - Shift Declined
 * * `SHIFT_EXPIRED` - Shift Expired
 * * `DECLINED` - Declined
 * * `INVITED` - Invited
 * * `OFFER_ENDED` - Offer Ended
 */
export type JobCandidateStageEnum = typeof JobCandidateStageEnum[keyof typeof JobCandidateStageEnum];


export const JobCandidateStageEnum = {
  APPLIED: 'APPLIED',
  SHIFT_OFFERED: 'SHIFT_OFFERED',
  SHIFT_SCHEDULED: 'SHIFT_SCHEDULED',
  JOB_OFFERED: 'JOB_OFFERED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  SHIFT_DECLINED: 'SHIFT_DECLINED',
  SHIFT_EXPIRED: 'SHIFT_EXPIRED',
  DECLINED: 'DECLINED',
  INVITED: 'INVITED',
  OFFER_ENDED: 'OFFER_ENDED',
} as const;
